package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.FandomSimpleIcons: ImageVector
    get() {
        if (_fandomSimpleIcons != null) {
            return _fandomSimpleIcons!!
        }
        _fandomSimpleIcons = Builder(name = "FandomSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(8.12f, 0.01f)
                arcToRelative(0.43f, 0.43f, 0.0f, false, false, -0.51f, 0.42f)
                verticalLineToRelative(9.75f)
                lineTo(4.10f, 6.67f)
                arcToRelative(0.43f, 0.43f, 0.0f, false, false, -0.66f, 0.06f)
                arcToRelative(0.43f, 0.43f, 0.0f, false, false, -0.07f, 0.24f)
                verticalLineToRelative(10.06f)
                arcToRelative(2.39f, 2.39f, 0.0f, false, false, 0.70f, 1.69f)
                lineToRelative(4.57f, 4.57f)
                arcToRelative(2.4f, 2.4f, 0.0f, false, false, 1.69f, 0.70f)
                horizontalLineToRelative(3.34f)
                curveToRelative(0.64f, 0.0f, 1.24f, -0.25f, 1.69f, -0.70f)
                lineToRelative(4.57f, -4.57f)
                arcToRelative(2.39f, 2.39f, 0.0f, false, false, 0.70f, -1.69f)
                verticalLineTo(13.41f)
                arcToRelative(2.39f, 2.39f, 0.0f, false, false, -0.7f, -1.69f)
                lineTo(8.34f, 0.13f)
                arcToRelative(0.43f, 0.43f, 0.0f, false, false, -0.22f, -0.12f)
                close()
                moveTo(9.65f, 12.51f)
                arcToRelative(0.72f, 0.72f, 0.0f, false, true, 0.51f, 0.21f)
                lineToRelative(1.85f, 1.85f)
                lineToRelative(1.84f, -1.85f)
                arcToRelative(0.71f, 0.71f, 0.0f, false, true, 1.02f, 0.0f)
                lineToRelative(1.32f, 1.32f)
                arcToRelative(0.72f, 0.72f, 0.0f, false, true, 0.21f, 0.51f)
                verticalLineToRelative(1.41f)
                arcToRelative(0.72f, 0.72f, 0.0f, false, true, -0.21f, 0.51f)
                lineToRelative(-3.68f, 3.7f)
                arcToRelative(0.72f, 0.72f, 0.0f, false, true, -1.02f, 0.0f)
                lineToRelative(-3.67f, -3.7f)
                arcToRelative(0.72f, 0.72f, 0.0f, false, true, -0.21f, -0.51f)
                verticalLineToRelative(-1.41f)
                arcToRelative(0.71f, 0.71f, 0.0f, false, true, 0.21f, -0.51f)
                lineToRelative(1.32f, -1.32f)
                arcToRelative(0.71f, 0.71f, 0.0f, false, true, 0.51f, -0.21f)
                close()
            }
        }
        .build()
        return _fandomSimpleIcons!!
    }

private var _fandomSimpleIcons: ImageVector? = null
